<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">CONTENTS</p>
<p class="cct"><span href="#/xhtml/title" title="Link target outside of Sample">TITLE PAGE</span></p>
<p class="cct"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">DEDICATION</span></p>
<p class="tx"> </p>
<p class="cct"><a href="#/xhtml/chapter1#ch1">PAIN WON’T KILL YOU (2011)</a></p>
<p class="cct"><a href="#/xhtml/chapter2#ch2">FARTHER AWAY (2011)</a></p>
<p class="cct1"><span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">THE GREATEST FAMILY EVER STORIED (2010)</span></p>
<p class="cct"><span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">HORNETS (2010)</span></p>
<p class="cct"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">THE UGLY MEDITERRANEAN (2010)</span></p>
<p class="cct"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">THE CORN KING (2010)</span></p>
<p class="cct1"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">ON AUTOBIOGRAPHICAL FICTION (2009)</span></p>
<p class="cct1"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">I JUST CALLED TO SAY I LOVE YOU (2008)</span></p>
<p class="cct"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">DAVID FOSTER WALLACE (2008)</span></p>
<p class="cct"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">THE CHINESE PUFFIN (2008)</span></p>
<p class="cct"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">ON <span class="epub-i">THE LAUGHING POLICEMAN</span> (2008)</span></p>
<p class="cct"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">COMMA-THEN (2008)</span></p>
<p class="cct1"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">AUTHENTIC BUT HORRIBLE (2007)</span></p>
<p class="cct"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">INTERVIEW WITH NEW YORK STATE (2007)</span></p>
<p class="cct1"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">LOVE LETTERS (2005)</span></p>
<p class="cct"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">OUR LITTLE PLANET (2005)</span></p>
<p class="cct"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">THE END OF THE BINGE (2005)</span></p>
<p class="cct1"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">WHAT MAKES YOU SO SURE YOU’RE NOT THE EVIL ONE YOURSELF? (2004)</span></p>
<p class="cct"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">OUR RELATIONS: A BRIEF HISTORY (2004)</span></p>
<p class="cct1"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">THE MAN IN THE GRAY FLANNEL SUIT (2002)</span></p>
<p class="cct1"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">NO END TO IT (1998)</span></p>
<p class="tx"> </p>
<p class="cct"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">ALSO BY JONATHAN FRANZEN</span></p>
<p class="cct"><span href="#/xhtml/copyright#copy" title="Link target outside of Sample">COPYRIGHT</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?87e93112